// extracted by mini-css-extract-plugin
export default {"container":"NQMzNZIpgFkx3pRl_gCJ","selectionGroup":"OBdCFRp5CznrqLebXUXb"};